module.exports = __webpack_public_path__ + "static/media/title.0adac3ff.png";